<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">Templates Categories Management <span class="badge badge-primary">{{
              count
            }}</span>
          </h5>
        </div>
        <div class="col-md-8 col-xs-12 align-self-center">
          <button
              @click="openModalCreateCategory"
              class="float-right ml-3 text-white btn btn-primary d-none d-md-block"
          >
            <i class="fas fa-plus"></i> Add Category
          </button>
          <nav aria-label="breadcrumb" class="mt-2 float-md-right float-left">
            <ol class="breadcrumb mb-0 justify-content-end p-0">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li aria-current="page" class="breadcrumb-item active">Templates Categories Managers</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-6">
                  <label for="slug">Search by category name</label>
                  <div class="input-group">
                  <span class="input-group-btn">
                    <button class="btn waves-effect waves-light btn-info" type="button">
                      <i class="fa fa-search"></i>
                    </button>
                  </span>
                    <input
                        v-model="textSearch"
                        class="form-control"
                        placeholder="Search by category name"
                        type="text"
                        @change="searchPresentation()"
                    />
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="slug">Show on Public Template Library</label>
                  <div class="input-group">
                    <select v-model="filters.active" class="form-control" @change="filter()">
                      <option value="">All</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="slug">Show for Presenter</label>
                  <div class="input-group">
                    <select v-model="filters.onlyPresenter" class="form-control" @change="filter()">
                      <option value="">All</option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="table-responsive">
                  <div class="text-center">
                    <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                  </div>
                  <table class="table table-category">
                    <thead>
                    <tr>
                      <th @click="sortByField('id')">
                        ID
                        <span v-if="sortBy ==='id'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('name')">
                        Name
                        <span v-if="sortBy ==='name'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('slug')">
                        Slug
                        <span v-if="sortBy ==='slug'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('createdAt')">
                        Created at
                        <span v-if="sortBy ==='createdAt'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('updatedAt')">
                        Updated at
                        <span v-if="sortBy ==='updatedAt'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('active')">
                        Show on Public Template Library
                        <span v-if="sortBy ==='active'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th @click="sortByField('onlyPresenter')">
                        Show for Presenter
                        <span v-if="sortBy ==='onlyPresenter'">
                        <i
                            v-if=" sortDesc "
                            aria-hidden="true"
                            class="fas fa-sort-down"
                        ></i>
                        <i
                            v-else
                            aria-hidden="true"
                            class="fas fa-sort-up"
                        ></i>
                      </span>
                      </th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in items" :key="index" class="pointer" @click="openDetailCategory(item)">
                      <td>{{ item.id }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.slug }}</td>
                      <td>{{ item.createdAt | dateTime }}</td>
                      <td>{{ item.updatedAt | dateTime }}</td>
                      <td>
                        <input v-model="item.active" name="active" type="checkbox"
                               @click.stop="patchCategory('active', item, index)">
                      </td>
                      <td>
                        <input v-model="item.onlyPresenter" name="onlyPresenter" type="checkbox"
                               @click.stop="patchCategory('onlyPresenter', item, index)">
                      </td>
                      <td>
                        <a href="#" @click.stop="deleteCategory(item)">Delete</a>
                      </td>

                    </tr>
                    </tbody>
                  </table>

                  <div class="overflow-auto" v-if="!isLoading">
                    <b-pagination v-model="page" :per-page="limit" :total-rows="count"></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config";

export default {
  name: "TemplatesCategories",
  data() {
    return {
      items: [],
      page: 1,
      limit: 30,
      count: 0,
      isLoading: false,
      sortDesc: true,
      sortBy: "id",
      textSearch: "",
      filters: {
        active: '',
        onlyPresenter: ''
      },
      errPropertyMapping: {},
      msgError: '',
      dataCategory: {},
      idOpenDetailCategory: null,
      isCreatingCategory: false,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
  },
  watch: {
    page: {
      handler: function () {
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    searchPresentation() {
      this.getData();
    },
    filter() {
      this.getData();
    },
    sortByField(field) {
      this.sortBy = field
      this.sortDesc = !this.sortDesc;

      this.getData();
    },
    getFilterData() {
      const filters = {}
      Object.keys(this.filters).forEach((keyFilter) => {
        if (this.filters[keyFilter] !== '') {
          filters[keyFilter] = this.filters[keyFilter]
        }
      })
      return filters
    },
    async getData() {
      this.isLoading = true
      let params = {
        page: this.page,
        limit: this.limit,
        filters: this.getFilterData(),
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };
      if (this.textSearch) {
        params.textSearch = this.textSearch
      }
      const res = await this.callApiGetData(params)
      this.isLoading = false
      if (!res) {
        return false
      }
      const results = res.body;
      this.items = results.data;
      this.count = results.total;
    },
    async callApiGetData(params) {
      try {
        return await this.$http
            .get(Config.api.getPresentationCategories, {
              params: params
            });
      } catch (e) {
        console.log(e)
        return false
      }
    },
    async callApiUpdateCategory(id, payload) {
      try {
        return await this.$http
            .patch(`${Config.api.updatePresentationCategories}/${id}`, payload);
      } catch (e) {
        console.log(e)
        return false
      }
    },
    async callApiDelete(ids) {
      console.log(ids)
      try {
        return await this.$http
            .delete(`${Config.api.deletePresentationCategories}`, {body: {ids}});
      } catch (e) {
        console.log(e)
        return false
      }
    },
    openDetailCategory(item) {
      this.$router.push({ name: "TemplateCategoryDetail", params: { id: item.id } });
    },
    async deleteCategory(category) {
      const id = category.id
      const isConfirmed = await this.$bvModal.msgBoxConfirm(`Are you sure to delete category: ${category.name}?`, {centered: true})
      if (!isConfirmed) {
        return
      }
      if (!await this.callApiDelete([id])) {
        this.$toasted.error('Delete category error!', {duration: 10000})
        return false
      }
      this.$toasted.success('Delete category success!', {duration: 500})
      if (this.items.length <= 1) {
        this.page--
      }
      this.getData();
      return true
    },
    openModalCreateCategory() {
      this.$router.push({ name: "TemplateCategoryCreate"});
    },
    async patchCategory(property, item, index) {
      const payload = {}
      payload[property] = !item[property]
      const res = await this.callApiUpdateCategory(item.id, payload);
      if (!res) {
        this.$toasted.error('Update category error!', {duration: 10000})
        this.items[index][property] = !payload[property]
        return false
      }
      this.$toasted.success('Update category success!', {duration: 500})
      return true
    },
  }
};
</script>
<style lang="scss" scoped>
.addUser-btn {
  background-color: #4f9af2;
  border-radius: 20px;
  border-color: #4f9af2;

  &:hover {
    background-color: #2785f0;
    border-color: #2785f0;
  }
}

.table-category {
  th {
    &:hover {
      cursor: pointer;
    }
  }
}

.form-create-category {
  .error {
    .msg-error {
      display: block;
      font-size: 0.75rem;
      color: #ff5050;
      padding-top: 5px;
    }
  }

  .msg-error {
    display: none;
  }
}

.btn-add-category {
  width: 100%;
}
</style>
